import { ReactElement } from 'react';

import { Spinner, Text } from '@/design-system/components/ui';

interface Props {
  open: boolean;
  text?: string;
}

export const LoadingBackdrop = ({ open, text }: Props): ReactElement => {
  if (!open) return <></>;

  return (
    <div
      className="tw:fixed tw:inset-0 tw:flex tw:items-center tw:justify-center tw:bg-black/50 tw:z-[1800]"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="tw:flex tw:flex-col tw:items-center tw:gap-4">
        <Spinner />
        {text && (
          <Text variant="body-lg" className="tw:text-white">
            {text}
          </Text>
        )}
      </div>
    </div>
  );
};
